import dayjs from "dayjs";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
// import { getPeriodicityLabelByValue } from "../../../utils/periodicity";
import { ButtonsActionCards } from "./ButtonsActionCards";
import { TranslateFn } from "../../../utils/types";

/**
 * Colonnes de la liste des cartes.
 *
 * Voir columnsBadges.tsx : meme correctif, meme raison. `i18n.t()` au niveau
 * module est evalue une seule fois a l'import, donc les en-tetes ne suivaient
 * pas un changement de langue.
 */
export const getColumnsCards = (t: TranslateFn) => [
  {
    header: t("collaborator.choiceOfType", "Choice of type"),
    field: "cardType",
  },
  {
    header: t("collaborator.choiceOfBrand", "Choice of brand"),
    field: "cardBrand",
  },
  {
    header: t("panel.vehicule.dateOfEmission", "Date of emission"),
    field: "",
    render: (data: Record<string, any>) => {
      return (
        <CustomTypography
          variant="default"
          text={
            data?.release_date
              ? dayjs(data.release_date).format("DD-MM-YYYY")
              : ""
          }
        />
      );
    },
  },
  { header: t("common.number", "Number"), field: "number" },
  {
    header: t("common.billing", "Billing"),
    field: "",
    render: (data: Record<string, any>) => {
      return (
        <CustomTypography
          variant="default"
          // text={getPeriodicityLabelByValue(data.name) ?? ""}
          text={data.name}
        />
      );
    },
  },
  {
    header: "",
    field: "",
    render: (data: Record<string, any>) => {
      return <ButtonsActionCards card={data as TCard} />;
    },
  },
];
